import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/sign-in',
    name: 'SignIn',
    meta: {
      title: 'Guavavet Sign In',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/SignIn.vue'),
  },
  {
    path: '/blogs',
    name: 'Blogs',
    meta: {
      title: 'Guavavet Blog',
    },
    alias: '/',
    component: () => import('../views/Blogs.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
